export const QUERY_REFETCH_INTERVAL_MS = 30_000;

export const API_TIMEOUT_MS = 10_000;
